import Quill from 'quill'

let Block = Quill.import('formats/image')
class Audio extends Block {
    static create(value) {
        let node = super.create(value)
        node.setAttribute('controls', 'controls')
        node.setAttribute('style', 'margin-right: 20px;')

        // node.setAttribute('style', 'width: 100px;height: 100px;border: 1px solid red;cursor:pointer;')
        // node.setAttribute('height', '100px')
        // node.setAttribute('border', '1px solid red')
        // node.setAttribute('src', 'http://img.saillingtech.com/18/08/09/18080916215587826.m4a')
        return node;
    }
}
Audio.blotName = 'audio';
Audio.className = 'ql-audio';
Audio.tagName = 'audio';

export default Audio



// WEBPACK FOOTER //
// ./src/components/public/editor/audio.js